import React, { useEffect, useState } from "react";
import { Link, redirect, useNavigate, useSearchParams } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  FacebookAuthProvider,
  fetchSignInMethodsForEmail,
  linkWithCredential,
  sendEmailVerification,
  signInWithEmailAndPassword,
  signInWithPopup,
  updateProfile,
} from "firebase/auth";
import {
  setDoc,
  doc,
  serverTimestamp,
  getFirestore,
  getDoc,
} from "firebase/firestore";
import { auth, db, facebookProvider, googleProvider } from "../FirebaseConfig";
import WebFont from "webfontloader";
import { UserAuth } from "../Context";
import { useForm, Controller } from "react-hook-form";
import { toastOptions } from "../lib/toastOptions";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import useUserCountry from "../StatesStore/UserCountry";
import { generateReferralCode } from "../lib/generateReferralCode";
import { handleInvite } from "../Referral/HandleInvite";
import IncrementInviteClicks from "../Referral/IncrementInviteClicks";
import TermsAndConditions from "./TermsAndConditions";
import { Button } from "react-bootstrap";
import useModalStore from "../StatesStore/ModalStore";
import useUserStore from "../StatesStore/UserStore";
import { storeReferralCode } from "../lib/storeReferralCode";
import { getAllStoredReferralCodes } from "../lib/storedReferralCode";
import { WelcomeUser } from "../EmailSystem/sendEmails";
import useUrlState from "../StatesStore/CurrentURL";
import usePointsStore from "../StatesStore/PointsTable";
import { checkIfEmailExists } from "../lib/checkIfEmailExists";
const Signup = () => {
  const { open, closeModal } = useModalStore();
  const navigate = useNavigate();
  const { logOut } = UserAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const country = useUserCountry((state) => state.country);
  //const createUser = useUserStore((state)=>state.createUser)
  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get("ref");
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { setUser, createId } = useUserStore(); //for storing user
  const { user } = UserAuth();
  const pointsTable = usePointsStore((state) => state.pointsTable);
  const url = useUrlState((state) => state.url);
  const redirectUser = useNavigate();
  googleProvider.addScope("email");
  facebookProvider.addScope("email");
  const googleLogoPath =
    process.env.PUBLIC_URL + "/assets/images/logo/google-logo.svg";
  const facebookLogoPath =
    process.env.PUBLIC_URL + "/assets/images/logo/facebook-logo.svg";

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState({
    name: "",
    email: "",
    pass: "",
    confirmPass: "",
  });

  useEffect(() => {
    if (inviteCode) {
      console.log("inviteCode", inviteCode);

      storeReferralCode(inviteCode);
      IncrementInviteClicks(inviteCode);
    }
    const referralCodes = getAllStoredReferralCodes();
    console.log("Referral Codes to be sent:", referralCodes);
  }, []);
  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, []);
  if (open) {
    closeModal();
  }

  const handleSubmission = async (e) => {
    setLoading(true);
    setSubmitButtonDisabled(true);
    e.preventDefault();
    const countryCode = "";
    const phoneNumber = "";
    const terms = false;
    //setting submit button disable to avoid user firing repeatitive events
    const regex = /^[a-zA-Z\s]*$/;
    // Validate if the fields are not empty
    if (!regex.test(name)) {
      setError((prevState) => ({
        ...prevState,
        name: "Name can only contain alphabets",
      }));
      setLoading(false);
      return;
    }
    if (pass.length < 6) {
      setError((prevState) => ({
        ...prevState,
        pass: "Password must be at least 6 characters",
      }));
      setLoading(false);
      return;
    }
    if ((await checkIfEmailExists(email)).exists) {
      setError((prevErrors) => ({
        ...prevErrors,
        email: "Email already exists",
      }));
      setLoading(false);
      return;
    }

    // Uppercase the first letter of each word
    const NAME = name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
    // Split full name into firstName and lastName
    const [firstName, ...lastNameArray] = NAME.split(" ");
    const lastName = lastNameArray.join(" ");

    // Convert the photo to base64

    try {
      const authUser = await createUserWithEmailAndPassword(auth, email, pass);
      console.log("authuser", authUser);
      //createUser(email,pass)
      // Set displayName using updateProfile
      await updateProfile(authUser.user, {
        displayName: NAME,
      });
      // Concatenate country code and phone number
      const fullPhoneNumber = `${countryCode}${phoneNumber}`;
      const userDocRef = doc(db, "users", authUser.user.uid);

      // Generate random numbers for followers, following, and postCount
      const followers = 0;
      const following = 0;
      const postCount = 0;
      const connectionCount = 0;
      const referralCode = generateReferralCode();
      try {
        // Use setDoc to create or update the document
        await setDoc(userDocRef, {
          email,
          userName: NAME,
          firstName,
          lastName,
          birthday: null,
          phoneNumber: fullPhoneNumber,
          overview: null,
          products: null,
          photo: null, // Set to null if photoBase64 is undefined
          userTitle: null,
          timestamp: serverTimestamp(),
          region: country || null,
          followers,
          following,
          postCount,
          connectionCount,
          underAge: null,
          parentalConsent: null,
          favCategories: [],
          gender: null,
          location: "",
          terms: terms, //adding this to users object in firestore
          heardAboutUs: "",
          referralCode: referralCode,
          isVerified: false,
        });
      } catch (error) {
        console.error(error, " SetDoc");
      }
      const newUser = {
        userName: NAME,
        email,
        firstName,
        lastName,
        birthday: null,
        phoneNumber: fullPhoneNumber,
        overview: null,
        products: null,
        photo: null, // Set to null if photoBase64 is undefined
        userTitle: null,
        timestamp: serverTimestamp(),
        region: country || null,
        followers,
        following,
        postCount,
        connectionCount,
        underAge: null,
        parentalConsent: null,
        favCategories: [],
        gender: null,
        location: "",
        terms: terms, //adding this to users object in firestore
        heardAboutUs: "",
        referralCode: referralCode,
        isVerified: false,
      };
      console.log("newUser", newUser);
      await setUser(newUser);
      createId(authUser.user.uid);
      // After sign-up, search for the user with the referral code and add invite
      handleInvite(inviteCode, authUser, email, pointsTable);
      console.log("Data", authUser.user);
      toast.success(
        "Check you inbox for email verification link",
        toastOptions
      );
      await sendEmailVerification(authUser.user)
        .then(() => {
          // Email verification sent!
          console.log("Email verification sent!");
          navigate("/VerifyEmail");
        })
        .catch((error) => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error(
            "Error sending email verification:",
            errorCode,
            errorMessage
          );
        });
    } catch (err) {
      setSubmitButtonDisabled(false);
      setLoading(false);
      console.error("Sign up error:", err);
      if (err.code === "auth/email-already-in-use") {
        setError((prevState) => ({
          ...prevState,
          email: "Email already exists",
        }));
      } else {
        console.error(err);
      }
      toast.error("Sign up failed. Please try again.", toastOptions);
    }
  };

  React.useEffect(() => {
    if (submitButtonDisabled) {
      console.log("button disables");
    }
  }, [submitButtonDisabled, logOut]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    WebFont.load({
      google: {
        families: ["Nunito Sans", "sans-serif"],
      },
    });
  }, []);
  const googleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      console.log("result", result);
      return result;
    } catch (error) {
      throw error;
    }
  };
  const facebookSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      console.log(result.user);
      return result;
    } catch (error) {
      if (error.code === "auth/account-exists-with-different-credential") {
        const pendingCred = FacebookAuthProvider.credentialFromError(error);
        const email = error.customData.email;
        const signInMethods = await fetchSignInMethodsForEmail(auth, email);
        console.log(signInMethods);
        if (signInMethods.includes("google.com")) {
          try {
            alert(
              "Account with this email " +
                email +
                " already exists. You need to login with gmail first in order to link both accounts"
            );
            const userCredential = await signInWithPopup(auth, googleProvider);
            await linkWithCredential(userCredential.user, pendingCred);
            console.log("Successfully linked existing account with Facebook");
          } catch (linkError) {
            console.error("Error linking credential:", linkError);
          }
        } else if (signInMethods.includes("password")) {
          try {
            const password = prompt(
              "Account with this email " +
                email +
                " already existed. Enter you password in order to link both accounts:"
            );
            const userCredential = await signInWithEmailAndPassword(
              auth,
              email,
              password
            ); // No password needed
            await linkWithCredential(userCredential.user, pendingCred);
            console.log("Successfully linked existing account with Facebook");
          } catch (linkError) {
            console.error("Error linking credential:", linkError);
          }
        } else {
          console.log("Other sign-in methods detected:", signInMethods);
          // Handle other provider linking if needed
        }
      } else {
        console.error("Error during sign-in:", error);
      }
    }
  };
  const handleGoogleSignIn = async () => {
    try {
      const result = await googleSignIn();
      // Check if the result is defined and has a 'user' property
      if (result && result.user) {
        // Extract user information from the Google sign-in result
        const { user } = result;
        if (user) {
          console.log("user google", user);
          // console.log(user.emailVerified);
          user.emailVerified = true;
          user.email = user.providerData[0].email;
          // console.log("BEFORE CREATING ID");
          createId(user.uid);
          if (!user.displayName) {
            const displayName = "DefaultDisplayName";
            await updateProfile(user, { displayName });
          }

          // Store user information in Firestore
          const db = getFirestore();
          const userRef = doc(db, "users", user.uid);

          // Check if the user already exists in Firestore
          const docSnap = await getDoc(userRef);
          console.log("here ser google", user);
          //new user
          await fetch(process.env.REACT_APP_API + "/api/updateEmailVerified", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ uid: user.uid }),
          })
            .then((response) =>
              console.log("Email verified Response", response.json())
            )
            .catch((error) => console.error("Email verified Catch", error));
          if (!docSnap.exists()) {
            await WelcomeUser(user.displayName, user.providerData[0]?.email);
            console.log("BEFORE SETING IT TRUE");
            auth.currentUser.emailVerified = true;

            const referralCode = generateReferralCode();
            const displayNameParts = (
              user.displayName || "DefaultDisplayName"
            ).split(" ");
            //make user dictionary
            const newUser = {
              userName: user.displayName || "DefaultDisplayName",
              email: user.email,
              firstName: displayNameParts[0] || null,
              lastName: displayNameParts.slice(1).join(" ") || null,
              birthday: user.birthday || null,
              phoneNumber: user.phoneNumber || null,
              gender: user.gender || null,
              photo: user.photoURL || null,
              overview: user.overview || null,
              products: user.products || null,
              timestamp: serverTimestamp(),
              location: null,
              userTitle: null,
              terms: false, //adding this to users object in firestore
              heardAboutUs: "",
              referralCode: referralCode,
              isVerified: true,
            };
            handleInvite(inviteCode, user.uid, user.email, pointsTable);
            //save the state of user
            await setUser(newUser);
            //set document in firestore here
            await setDoc(userRef, newUser);
            //user has no gender or birthday
            try {
              toast.success("Sign in with google successfull!", toastOptions);
              //redirect to more questions
              redirectUser("/SignInInput");
            } catch (error) {
              console.log("Error Signing in");
              toast.error("Sign up failed. Please try again.", toastOptions);
              redirect("/SignIn");
            }
          } else {
            console.log("GOING BACK TO OLD URL BYEEE!!");
            if (user.gender === null || user.birthday === null)
              redirectUser("/SignInInput");
            redirectUser(url);
          }
        }
      }
    } catch (error) {
      console.error("Error during Google sign-in:", error);
      if (error.code === "auth/popup-closed-by-user") {
        // alert("Google Sign-In popup closed. Please try again.");
        redirectUser("/SignIn");
      } else if (error.code === "auth/cancelled-popup-request") {
        console.error(error);
        // alert("Google Sign-In request cancelled. Please try again.");
      } else {
        console.error(error);
        // alert("Google Sign-In failed. Please try again.");
      }
    }
  };

  const handleFacebookSignIn = async () => {
    try {
      const result = await facebookSignIn();
      console.log(result);
      // Check if the result is defined and has a 'user' property
      if (result && result.user) {
        // Extract user information from the Google sign-in result
        const { user } = result;
        if (user) {
          console.log("user facebook", user);
          createId(user.uid);
          if (!user.displayName) {
            const displayName = "DefaultDisplayName";
            await updateProfile(user, { displayName });
          }

          // Store user information in Firestore
          const db = getFirestore();
          const userRef = doc(db, "users", user.uid);

          // Check if the user already exists in Firestore
          const docSnap = await getDoc(userRef);
          console.log("here ser facebook", user);
          //new user
          if (!docSnap.exists()) {
            await WelcomeUser(user.displayName, user.providerData[0]?.email);
            fetch(
              "https://us-central1-duplookflock-beada.cloudfunctions.net/api/api/updateEmailVerified",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ uid: user.uid }),
              }
            );
            auth.currentUser.emailVerified = true;
            const referralCode = generateReferralCode();
            const displayNameParts = (
              user.displayName || "DefaultDisplayName"
            ).split(" ");
            //make user dictionary
            const newUser = {
              userName: user.displayName || "DefaultDisplayName",
              email: user.email,
              firstName: displayNameParts[0] || null,
              lastName: displayNameParts.slice(1).join(" ") || null,
              birthday: user.birthday || null,
              phoneNumber: user.phoneNumber || null,
              gender: user.gender || null,
              photo: user.photoURL || null,
              overview: user.overview || null,
              products: user.products || null,
              timestamp: serverTimestamp(),
              location: null,
              userTitle: null,
              terms: false, //adding this to users object in firestore
              heardAboutUs: "",
              referralCode: referralCode,
              isVerified: true,
            };
            handleInvite(inviteCode, user.uid, user.email, pointsTable);
            //user has no gender or birthday
            //save the state of user
            await setUser(newUser);
            //set document in firestore here
            await setDoc(userRef, newUser);
            //redirect to gender/birthday compoennt
            try {
              toast.success("Sign in with Facebook successfull!", toastOptions);
              //redirect to more questions
              redirectUser("/SignInInput");
            } catch (error) {
              console.log("Error Signing in");
              toast.error("Sign up failed. Please try again.", toastOptions);
              redirect("/SignIn");
            }
          } else {
            redirectUser(url);
          }
        }
      }
    } catch (error) {
      console.error("Error during Facebook sign-in:", error);
      if (error.code === "auth/popup-closed-by-user") {
        // alert("Facebook Sign-In popup closed. Please try again.");
        redirectUser("/login");
      } else if (error.code === "auth/cancelled-popup-request") {
        console.error(error);
        // alert("Facebook Sign-In request cancelled. Please try again.");
      } else {
        console.error(error);
        // alert("Facebook Sign-In failed. Please try again.");
      }
    }
  };
  return (
    <>
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100 py-2">
          <div className="col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-5">
            <div
              className="rounded-3"
              style={{
                backgroundColor: "white",
                padding: `1.5rem ${isSmallScreen ? "2rem" : "3.5rem"}`,
              }}
            >
              <div
                className="text-center mb-1"
                style={{ lineHeight: "0.5rem" }}
              >
                <h3
                  style={{
                    fontFamily: "Playfair Display",
                    fontWeight: 600,
                    fontSize: "1.85rem",
                  }}
                >
                  Welcome to Lookflock
                </h3>
                <p
                  style={{
                    fontFamily: "Open Sans",
                    fontWeight: 400,
                    fontSize: "1rem",
                  }}
                >
                  Find new fashion ideas to try
                </p>
              </div>
              <div className="d-flex flex-column gap-2">
                <form
                  onSubmit={(e) => handleSubmission(e)}
                  className="d-flex flex-column gap-2"
                >
                  <div>
                    <label
                      htmlFor="nameInput"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 600,
                        fontSize: "0.8rem",
                      }}
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        setError({ ...error, name: "" });
                        setSubmitButtonDisabled(false);
                      }}
                      id="nameInput"
                      className="form-control rounded-3"
                      placeholder="Full Name"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                        fontSize: "1rem",
                        width: "100%",
                      }}
                      required
                    />
                    <div
                      className="text-danger"
                      style={{
                        fontSize: "0.8rem",
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                      }}
                    >
                      {error.name}
                    </div>
                  </div>
                  <div>
                    <label
                      htmlFor="emailInput"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 600,
                        fontSize: "0.8rem",
                      }}
                    >
                      Email address
                    </label>
                    <input
                      type="email"
                      id="emailInput"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setError({ ...error, email: "" });
                        setSubmitButtonDisabled(false);
                      }}
                      className="form-control rounded-3"
                      placeholder="Email"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                        fontSize: "1rem",
                        width: "100%",
                      }}
                      required
                    />
                    <div
                      className="text-danger"
                      style={{
                        fontSize: "0.8rem",
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                      }}
                    >
                      {error.email}
                    </div>
                  </div>
                  <div className="position-relative">
                    <label
                      htmlFor="passwordInput"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 600,
                        fontSize: "0.8rem",
                        marginBottom: "0rem",
                      }}
                    >
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      value={pass}
                      onChange={(e) => {
                        setPass(e.target.value);
                        setError({ ...error, pass: "" });
                      }}
                      id="passwordInput"
                      className="form-control rounded-3"
                      placeholder="Create a password"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                        fontSize: "1rem",
                        width: "100%",
                      }}
                      required
                    />
                    <button
                      type="button"
                      className="btn position-absolute end-0 translate-middle-y"
                      style={{ zIndex: 1, top: "2.75rem" }}
                      onClick={() => {
                        setShowPassword((prevState) => !prevState);
                        setSubmitButtonDisabled(false);
                      }}
                    >
                      <i
                        className={`bi bi-${
                          showPassword ? "eye-slash-fill" : "eye-fill"
                        }`}
                        style={{ fontSize: "1rem" }}
                      ></i>
                    </button>
                    <div
                      className="text-danger"
                      style={{
                        fontSize: "0.8rem",
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                      }}
                    >
                      {error.pass}
                    </div>
                  </div>
                  <div className="position-relative">
                    <label
                      htmlFor="confirmPasswordInput"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 600,
                        fontSize: "0.8rem",
                        marginBottom: "0rem",
                      }}
                    >
                      Confirm Password
                    </label>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPass}
                      onChange={(e) => {
                        setConfirmPass(e.target.value);
                        setError({ ...error, confirmPass: "" });
                      }}
                      id="confirmPasswordInput"
                      className="form-control rounded-3"
                      placeholder="Confirm your password"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                        fontSize: "1rem",
                        width: "100%",
                      }}
                      required
                    />
                    <button
                      type="button"
                      className="btn position-absolute end-0 translate-middle-y"
                      style={{ zIndex: 1, top: "2.75rem" }}
                      onClick={() => {
                        setShowConfirmPassword((prevState) => !prevState);
                        setSubmitButtonDisabled(false);
                      }}
                      disabled={submitButtonDisabled}
                    >
                      <i
                        className={`bi bi-${
                          showConfirmPassword ? "eye-slash-fill" : "eye-fill"
                        }`}
                        style={{ fontSize: "1rem" }}
                      ></i>
                    </button>
                    <div
                      className="text-danger"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                        fontSize: "0.8rem",
                      }}
                    >
                      {pass !== confirmPass &&
                        "Password and Confirm Password do not match."}
                    </div>
                  </div>
                  <div>
                    {loading ? (
                      <div
                        className="btn rounded-3 mt-1 py-2"
                        style={{
                          fontFamily: "Open Sans",
                          fontWeight: 400,
                          fontSize: "1rem",
                          width: "100%",
                          backgroundColor: "#1C6751",
                          color: "white",
                          cursor: "default",
                          opacity: "0.65",
                        }}
                      >
                        <div
                          className="spinner-border text-white"
                          style={{ width: "1rem", height: "1rem" }}
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <button
                        type="submit"
                        disabled={submitButtonDisabled}
                        className="btn rounded-3 mt-1 py-2"
                        style={{
                          fontFamily: "Open Sans",
                          fontWeight: 400,
                          fontSize: "1rem",
                          width: "100%",
                          backgroundColor: "#1C6751",
                          color: "white",
                        }}
                      >
                        Sign Up
                      </button>
                    )}
                  </div>
                </form>

                <div
                  className="text-center"
                  style={{ fontFamily: "Open Sans", fontWeight: 600 }}
                >
                  OR
                </div>
                <div className="d-flex justify-content-center align-items-center gap-3">
                  <button
                    type="submit"
                    className="btn pt-0"
                    onClick={handleGoogleSignIn}
                    style={{
                      fontFamily: "Open Sans",
                      fontWeight: 600,
                      fontSize: "1rem",
                    }}
                  >
                    <img
                      src={googleLogoPath}
                      className="mx-1"
                      alt="Google"
                      style={{
                        width: "35px",
                        height: "35px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </button>
                  <button
                    type="submit"
                    className="btn pt-0"
                    onClick={handleFacebookSignIn}
                    style={{
                      fontFamily: "Open Sans",
                      fontWeight: 600,
                      fontSize: "1rem",
                    }}
                  >
                    <img
                      src={facebookLogoPath}
                      className="mx-1"
                      alt="Google"
                      style={{
                        width: "35px",
                        height: "35px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </button>
                </div>
                <TermsAndConditions />
                <p
                  className="text-center px-4 m-0"
                  style={{
                    fontFamily: "Open Sans",
                    fontWeight: 600,
                    fontSize: "0.75rem",
                  }}
                >
                  Already a member?{" "}
                  <Link
                    style={{ color: "black", textDecoration: "underline" }}
                    to="/SignIn"
                  >
                    Login
                  </Link>
                </p>
                <p
                  className="text-center px-0 m-0"
                  style={{
                    fontFamily: "Open Sans",
                    fontWeight: 400,
                    fontSize: "0.7rem",
                  }}
                >
                  ©2025 Lookflock. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
